/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateUser = /* GraphQL */ `subscription OnCreateUser(
  $filter: ModelSubscriptionUserFilterInput
  $owner: String
) {
  onCreateUser(filter: $filter, owner: $owner) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser(
  $filter: ModelSubscriptionUserFilterInput
  $owner: String
) {
  onUpdateUser(filter: $filter, owner: $owner) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser(
  $filter: ModelSubscriptionUserFilterInput
  $owner: String
) {
  onDeleteUser(filter: $filter, owner: $owner) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreateLocation = /* GraphQL */ `subscription OnCreateLocation($filter: ModelSubscriptionLocationFilterInput) {
  onCreateLocation(filter: $filter) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLocationSubscriptionVariables,
  APITypes.OnCreateLocationSubscription
>;
export const onUpdateLocation = /* GraphQL */ `subscription OnUpdateLocation($filter: ModelSubscriptionLocationFilterInput) {
  onUpdateLocation(filter: $filter) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLocationSubscriptionVariables,
  APITypes.OnUpdateLocationSubscription
>;
export const onDeleteLocation = /* GraphQL */ `subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
  onDeleteLocation(filter: $filter) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLocationSubscriptionVariables,
  APITypes.OnDeleteLocationSubscription
>;
export const onCreatePatient = /* GraphQL */ `subscription OnCreatePatient($filter: ModelSubscriptionPatientFilterInput) {
  onCreatePatient(filter: $filter) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePatientSubscriptionVariables,
  APITypes.OnCreatePatientSubscription
>;
export const onUpdatePatient = /* GraphQL */ `subscription OnUpdatePatient($filter: ModelSubscriptionPatientFilterInput) {
  onUpdatePatient(filter: $filter) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePatientSubscriptionVariables,
  APITypes.OnUpdatePatientSubscription
>;
export const onDeletePatient = /* GraphQL */ `subscription OnDeletePatient($filter: ModelSubscriptionPatientFilterInput) {
  onDeletePatient(filter: $filter) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePatientSubscriptionVariables,
  APITypes.OnDeletePatientSubscription
>;
export const onCreateCase = /* GraphQL */ `subscription OnCreateCase($filter: ModelSubscriptionCaseFilterInput) {
  onCreateCase(filter: $filter) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseSubscriptionVariables,
  APITypes.OnCreateCaseSubscription
>;
export const onUpdateCase = /* GraphQL */ `subscription OnUpdateCase($filter: ModelSubscriptionCaseFilterInput) {
  onUpdateCase(filter: $filter) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseSubscriptionVariables,
  APITypes.OnUpdateCaseSubscription
>;
export const onDeleteCase = /* GraphQL */ `subscription OnDeleteCase($filter: ModelSubscriptionCaseFilterInput) {
  onDeleteCase(filter: $filter) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseSubscriptionVariables,
  APITypes.OnDeleteCaseSubscription
>;
export const onCreateDetails = /* GraphQL */ `subscription OnCreateDetails($filter: ModelSubscriptionDetailsFilterInput) {
  onCreateDetails(filter: $filter) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDetailsSubscriptionVariables,
  APITypes.OnCreateDetailsSubscription
>;
export const onUpdateDetails = /* GraphQL */ `subscription OnUpdateDetails($filter: ModelSubscriptionDetailsFilterInput) {
  onUpdateDetails(filter: $filter) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDetailsSubscriptionVariables,
  APITypes.OnUpdateDetailsSubscription
>;
export const onDeleteDetails = /* GraphQL */ `subscription OnDeleteDetails($filter: ModelSubscriptionDetailsFilterInput) {
  onDeleteDetails(filter: $filter) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDetailsSubscriptionVariables,
  APITypes.OnDeleteDetailsSubscription
>;
export const onCreateRecording = /* GraphQL */ `subscription OnCreateRecording($filter: ModelSubscriptionRecordingFilterInput) {
  onCreateRecording(filter: $filter) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecordingSubscriptionVariables,
  APITypes.OnCreateRecordingSubscription
>;
export const onUpdateRecording = /* GraphQL */ `subscription OnUpdateRecording($filter: ModelSubscriptionRecordingFilterInput) {
  onUpdateRecording(filter: $filter) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecordingSubscriptionVariables,
  APITypes.OnUpdateRecordingSubscription
>;
export const onDeleteRecording = /* GraphQL */ `subscription OnDeleteRecording($filter: ModelSubscriptionRecordingFilterInput) {
  onDeleteRecording(filter: $filter) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecordingSubscriptionVariables,
  APITypes.OnDeleteRecordingSubscription
>;
export const onCreateBillingCodes = /* GraphQL */ `subscription OnCreateBillingCodes(
  $filter: ModelSubscriptionBillingCodesFilterInput
) {
  onCreateBillingCodes(filter: $filter) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBillingCodesSubscriptionVariables,
  APITypes.OnCreateBillingCodesSubscription
>;
export const onUpdateBillingCodes = /* GraphQL */ `subscription OnUpdateBillingCodes(
  $filter: ModelSubscriptionBillingCodesFilterInput
) {
  onUpdateBillingCodes(filter: $filter) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBillingCodesSubscriptionVariables,
  APITypes.OnUpdateBillingCodesSubscription
>;
export const onDeleteBillingCodes = /* GraphQL */ `subscription OnDeleteBillingCodes(
  $filter: ModelSubscriptionBillingCodesFilterInput
) {
  onDeleteBillingCodes(filter: $filter) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBillingCodesSubscriptionVariables,
  APITypes.OnDeleteBillingCodesSubscription
>;
export const onCreateTemplate = /* GraphQL */ `subscription OnCreateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onCreateTemplate(filter: $filter) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateSubscriptionVariables,
  APITypes.OnCreateTemplateSubscription
>;
export const onUpdateTemplate = /* GraphQL */ `subscription OnUpdateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onUpdateTemplate(filter: $filter) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateSubscriptionVariables,
  APITypes.OnUpdateTemplateSubscription
>;
export const onDeleteTemplate = /* GraphQL */ `subscription OnDeleteTemplate($filter: ModelSubscriptionTemplateFilterInput) {
  onDeleteTemplate(filter: $filter) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateSubscriptionVariables,
  APITypes.OnDeleteTemplateSubscription
>;
export const onCreateTemplateSection = /* GraphQL */ `subscription OnCreateTemplateSection(
  $filter: ModelSubscriptionTemplateSectionFilterInput
) {
  onCreateTemplateSection(filter: $filter) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateSectionSubscriptionVariables,
  APITypes.OnCreateTemplateSectionSubscription
>;
export const onUpdateTemplateSection = /* GraphQL */ `subscription OnUpdateTemplateSection(
  $filter: ModelSubscriptionTemplateSectionFilterInput
) {
  onUpdateTemplateSection(filter: $filter) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateSectionSubscriptionVariables,
  APITypes.OnUpdateTemplateSectionSubscription
>;
export const onDeleteTemplateSection = /* GraphQL */ `subscription OnDeleteTemplateSection(
  $filter: ModelSubscriptionTemplateSectionFilterInput
) {
  onDeleteTemplateSection(filter: $filter) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateSectionSubscriptionVariables,
  APITypes.OnDeleteTemplateSectionSubscription
>;
export const onCreateTemplateTextbox = /* GraphQL */ `subscription OnCreateTemplateTextbox(
  $filter: ModelSubscriptionTemplateTextboxFilterInput
) {
  onCreateTemplateTextbox(filter: $filter) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateTextboxSubscriptionVariables,
  APITypes.OnCreateTemplateTextboxSubscription
>;
export const onUpdateTemplateTextbox = /* GraphQL */ `subscription OnUpdateTemplateTextbox(
  $filter: ModelSubscriptionTemplateTextboxFilterInput
) {
  onUpdateTemplateTextbox(filter: $filter) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateTextboxSubscriptionVariables,
  APITypes.OnUpdateTemplateTextboxSubscription
>;
export const onDeleteTemplateTextbox = /* GraphQL */ `subscription OnDeleteTemplateTextbox(
  $filter: ModelSubscriptionTemplateTextboxFilterInput
) {
  onDeleteTemplateTextbox(filter: $filter) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateTextboxSubscriptionVariables,
  APITypes.OnDeleteTemplateTextboxSubscription
>;
export const onCreateTemplateSubsection = /* GraphQL */ `subscription OnCreateTemplateSubsection(
  $filter: ModelSubscriptionTemplateSubsectionFilterInput
) {
  onCreateTemplateSubsection(filter: $filter) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateSubsectionSubscriptionVariables,
  APITypes.OnCreateTemplateSubsectionSubscription
>;
export const onUpdateTemplateSubsection = /* GraphQL */ `subscription OnUpdateTemplateSubsection(
  $filter: ModelSubscriptionTemplateSubsectionFilterInput
) {
  onUpdateTemplateSubsection(filter: $filter) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateSubsectionSubscriptionVariables,
  APITypes.OnUpdateTemplateSubsectionSubscription
>;
export const onDeleteTemplateSubsection = /* GraphQL */ `subscription OnDeleteTemplateSubsection(
  $filter: ModelSubscriptionTemplateSubsectionFilterInput
) {
  onDeleteTemplateSubsection(filter: $filter) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateSubsectionSubscriptionVariables,
  APITypes.OnDeleteTemplateSubsectionSubscription
>;
export const onCreateTemplateField = /* GraphQL */ `subscription OnCreateTemplateField(
  $filter: ModelSubscriptionTemplateFieldFilterInput
) {
  onCreateTemplateField(filter: $filter) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTemplateFieldSubscriptionVariables,
  APITypes.OnCreateTemplateFieldSubscription
>;
export const onUpdateTemplateField = /* GraphQL */ `subscription OnUpdateTemplateField(
  $filter: ModelSubscriptionTemplateFieldFilterInput
) {
  onUpdateTemplateField(filter: $filter) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTemplateFieldSubscriptionVariables,
  APITypes.OnUpdateTemplateFieldSubscription
>;
export const onDeleteTemplateField = /* GraphQL */ `subscription OnDeleteTemplateField(
  $filter: ModelSubscriptionTemplateFieldFilterInput
) {
  onDeleteTemplateField(filter: $filter) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTemplateFieldSubscriptionVariables,
  APITypes.OnDeleteTemplateFieldSubscription
>;
